import bpcActuals from './bpc-actuals.json'
import kpiLabels from './kpi-labels.json'
import notifications from './notifications.json'
import periodDataIssues from './period-data-issues.json'
import subChannels from './sub-channels.json'
import welcome from './welcome.json'

export default {
  ...bpcActuals,
  ...kpiLabels,
  ...notifications,
  ...periodDataIssues,
  ...subChannels,
  ...welcome,
}
